export const salutation = [
    { label: "Mr.", value: "Mr" },
    { label: "Ms.", value: "Ms" },
    { label: "Mrs.", value: "Mrs" },
    { label: "Miss", value: "Miss" },
    { label: "Dr.", value: "Dr" },
    { label: "Prof.", value: "Prof" },
    { label: "Mx.", value: "Mx" },
    { label: "Rev.", value: "Rev" },
    { label: "Hon.", value: "Hon" },
    { label: "Sir", value: "Sir" },
    { label: "Lady", value: "Lady" },
    { label: "Master", value: "Master" },
    { label: "Capt.", value: "Capt" },
    { label: "Col.", value: "Col" },
    { label: "Maj.", value: "Maj" },
    { label: "Lt.", value: "Lt" },
    { label: "Sgt.", value: "Sgt" },
    { label: "Cpl.", value: "Cpl" }
]